import { render, staticRenderFns } from "./ColorSwatch3D.vue?vue&type=template&id=f5d0881a&scoped=true&"
import script from "./ColorSwatch3D.vue?vue&type=script&lang=ts&"
export * from "./ColorSwatch3D.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSwatch3D.vue?vue&type=style&index=0&id=f5d0881a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d0881a",
  null
  
)

export default component.exports